
import axios from 'axios';
import config from '../../config';
import { getAxiosConfigUserToken } from '../../util/utilFunction';

export const getItemAssignedByUserIdApi = async(userId)=>{
    const url = `${config.apiUrl}/v1/itemAssigned/byUserId/${userId}`;
    return await axios.get(url,getAxiosConfigUserToken())
    .then(response => response.data)
 }
 
export const getItemAssignedByUserIdAndprojectIdApi = async(userId,projectId)=>{
   const url = `${config.apiUrl}/v1/itemAssigned/byUserIdAndProjectId/${userId}/${projectId}/`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
}

 
 export const getItemNotAssignedByInstitutionIdApi = async(inst)=>{
    const url = `${config.apiUrl}/v1/itemAssigned/notAssignedByInst/${inst}`;
    return await axios.get(url,getAxiosConfigUserToken())
    .then(response => response.data)
 } 
 export const getItemNotAssignedByProjectIdApi = async(projectId)=>{
   const url = `${config.apiUrl}/v1/itemAssigned/notAssignedByProjectId/${projectId}`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
} 
 export const getItemNotAssignedByInstitutionIdAnJournalIdApi = async(inst,journalId)=>{
   const url = `${config.apiUrl}/v1/itemAssigned/notAssignedByInstAndJournalId/${inst}/${journalId}`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
} 

 export const getItemAssignedByProjectIdApi = async(projectId)=>{
   const url = `${config.apiUrl}/v1/itemAssigned/byProjectId/${projectId}`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
} 
export const postSaveItemAssignedApi = (itemAssigned)=>{
   const url = `${config.apiUrl}/v1/itemAssigned/`;
   return axios.post(url,itemAssigned,getAxiosConfigUserToken())
   .then(response => response.data);
}

export const deleteItemAssignedByIdApi = async(id)=>{
   const url = `${config.apiUrl}/v1/itemAssigned/${id}`;
   return await axios.delete(url,getAxiosConfigUserToken())
   .then(response => response.data)
}
export const deleteItemAssigned = async(itemAssigned)=>{
   const url = `${config.apiUrl}/v1/itemAssigned/delete/`;
   return await axios.post(url,itemAssigned,getAxiosConfigUserToken())
   .then(response => response.data)
}
export const putUpdateItemAssignedByIdApi = async(itemAssigned)=>{
   const url = `${config.apiUrl}/v1/itemAssigned/`;
   return await axios.put(url,itemAssigned,getAxiosConfigUserToken())
   .then(response => response.data)
}

export const getItemAssignedByItemIdApi = async(itemId)=>{
   const url = `${config.apiUrl}/v1/itemAssigned/byItemId/${itemId}`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
} 